import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import axios from '@/services/axiosInstance'

export const useUserStore = defineStore('user', () => {
  // State
  const user = ref(null)
  const credits = ref(0)

  // Getters
  const isAuthenticated = computed(() => !!user.value)
  const formattedCredits = computed(() => credits.value?.toFixed(2) || '0.00')

  // Actions
  async function fetchUser () {
    try {
      const { data } = await axios.get('/user')
      if (data && typeof data.credits !== 'undefined') {
        user.value = data
        credits.value = data.credits
      } else {
        // If we get invalid data, treat it as logged out
        clearUser()
      }
    } catch (error) {
      // Any error fetching user (like 401 Unauthorized) means they are not logged in
      clearUser()
    }
  }

  function setCredits (newCredits) {
    if (typeof newCredits === 'number') {
      credits.value = newCredits
    }
  }

  function clearUser () {
    user.value = null
    credits.value = 0

    localStorage.removeItem('user-token')
  }

  return { user, credits, isAuthenticated, formattedCredits, fetchUser, setCredits, clearUser }
})
